// Partner-Pharmacies constants.

export const OCP_LOOKUP_URL = "https://members.ocpinfo.com/tcpr/public/pr/en/";

export const CANADIAN_PROVINCES = [
  { code: "AB", name: "Alberta" },
  { code: "BC", name: "British Columbia" },
  { code: "MB", name: "Manitoba" },
  { code: "NB", name: "New Brunswick" },
  { code: "NL", name: "Newfoundland and Labrador" },
  { code: "NS", name: "Nova Scotia" },
  { code: "NT", name: "Northwest Territories" },
  { code: "NU", name: "Nunavut" },
  { code: "ON", name: "Ontario" },
  { code: "PE", name: "Prince Edward Island" },
  { code: "QC", name: "Quebec" },
  { code: "SK", name: "Saskatchewan" },
  { code: "YT", name: "Yukon" },
];

// Medication → allowed quantities & fee lookup.
// Standard 3-month drugs: 28 (single month, $350) or 84 (full course, $1050).
// Maviret is a 2-month treatment: 28 ($350) or 56 ($700). 56 is only ever
// valid for Maviret; 84 is not used for Maviret.
export const MEDICATION_RULES = {
  Epclusa: { quantities: [28, 84], fees: { 28: 350, 84: 1050 } },
  Vosevi:  { quantities: [28, 84], fees: { 28: 350, 84: 1050 } },
  Harvoni: { quantities: [28, 84], fees: { 28: 350, 84: 1050 } },
  Maviret: { quantities: [28, 56], fees: { 28: 350, 56: 700 } },
};

export const feeFor = (medication, quantity) => {
  const rule = MEDICATION_RULES[medication];
  if (!rule) return null;
  const q = Number(quantity);
  return rule.fees[q] ?? null;
};

export const quantitiesFor = (medication) => {
  const rule = MEDICATION_RULES[medication];
  return rule ? rule.quantities : null;
};
